<script setup lang="ts">
import useVueformResponseErrors from 'vueform/src/VueformResponseErrors';
import type {JText} from 'joomla/joomla.interface';
import {ref, type Ref} from "vue";

const groups: string = Joomla.getOptions('configuration').groups
const jText: JText = Joomla.JText

let completed: Ref<boolean> = ref(false)

function success(): void {
  const isInPopup = Joomla.getOptions('configuration').renderInPopup;
  let formSuccessSelector = '.product-subscription-form .form-success';
  let introSelector = '.product-subscription-form .intro';
  if (isInPopup) {
    const popupSelector = '.form-popup '
    formSuccessSelector = popupSelector + formSuccessSelector;
    introSelector = popupSelector + introSelector;
  }
  document.querySelector<HTMLElement>(formSuccessSelector)!.style.display = 'block'
  document.querySelector<HTMLElement>(introSelector)!.style.display = 'none'
  completed.value = true
}

</script>
<template>
  <Vueform ref="form" v-if="!completed" form-key="product-subscription" @response="useVueformResponseErrors as any"
           @success="success">
    <CheckboxElement
        name="privacy_confirmation"
        rules="required"
        :field-name="jText._('MOD_REACTIVE_FORMS_VALIDATION_ATTRIBUTE_PRIVACY_CONFIRMATION')"
        :text="jText._('MOD_REACTIVE_FORMS_LVM_PRODUCT_SUBSCRIPTION_PRIVACY_CONFIRMATION_TEXT')"
    />
    <CheckboxgroupElement
        name="groups"
        rules="min:1"
        :label="jText._('MOD_REACTIVE_FORMS_LVM_PRODUCT_SUBSCRIPTION_GROUPS_FIELD_LABEL')"
        :items="groups"
    />
    <StaticElement name="text" tag="p"
                   :content="jText._('MOD_REACTIVE_FORMS_LVM_PRODUCT_SUBSCRIPTION_FORM_INSTRUCTION')"/>
    <TextElement
        name="name"
        rules="required"
        :label="jText._('MOD_REACTIVE_FORMS_LVM_PRODUCT_SUBSCRIPTION_NAME_LABEL') + '*'"
    />
    <TextElement
        name="email"
        rules="required|email:debounce=1000"
        :label="jText._('MOD_REACTIVE_FORMS_VALIDATION_ATTRIBUTE_EMAIL') + '*'"
        :columns="{ default: 12, md: 6 }"
    />
    <TextElement
        name="phone_number"
        rules="nullable|digits:8"
        input-type="number"
        :label="jText._('MOD_REACTIVE_FORMS_VALIDATION_ATTRIBUTE_PHONE_NUMBER')"
        :debounce="1000"
        :add-class="{input: ['phone-number']}"
        :addons="{ before: '+371'}"
        :columns="{ default: 12, md: 6 }"
    />
    <StaticElement name="text" :content="jText._('MOD_REACTIVE_FORMS_LVM_PRODUCT_SUBSCRIPTION_MANDATORY_FIELDS')"/>
    <CaptchaElement name="g_recaptcha_response"/>
    <ButtonElement
        name="submit"
        align="left"
        :button-label="jText._('MOD_REACTIVE_FORMS_LVM_PRODUCT_SUBSCRIPTION_SUBMIT_BUTTON_LABEL')"
        :submits="true"
        :add-class="{button: ['btn']}"
    />
  </Vueform>
</template>